
import {getVideoDuration, formatTime} from '/services/helpers'

export default
	props:
		layout:
			type: String
			validator: (val) -> val in ['compact', 'regular']
			default: 'regular'

		video:
			type: Array
			required: true

		title:
			type: String

		subtitle:
			type: String

		description:
			type: String

		buttons:
			type: Array

	data: ->
		duration: null

	computed:
		computedVideo: -> @video[0]
		thumbnail: -> @computedVideo?.thumbnail
		videoAsset: ->
			if @computedVideo?.videoMobile?[0] && @$store.state.layout.viewport.width <= 768
			then return @computedVideo.videoMobile[0]
			if @computedVideo.videoDesktop?[0] then return @computedVideo.videoDesktop[0]
			return undefined
		videoUrl: -> @videoAsset?.url
		computedTitle: -> @title || @computedVideo.title
		computedSubtitle: -> @subtitle || @computedVideo.subheading
		computedDescription: -> @description || @computedVideo.shortDescription
		classes: -> [
			@layout
		]

	mounted: ->
		return unless @$refs.media and @videoUrl
		getVideoDuration(@videoUrl).then((duration) =>
			@duration = formatTime duration
		)

	methods:
		play: ->
			return unless @videoAsset

			@$store.commit 'videoModal/play', {
				video: @videoAsset,
				title: @computedTitle,
				subtitles: @videoAsset.subtitles
				libraryVideoId: @videoAsset.id
			}


